import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import FirstResponderHomeBuyingPage from "@/pages/tools/FirstResponderHomeBuying";

export const Route = createFileRoute("/tools/first-responder-home-buying")({
  head: () => seoHead("/tools/first-responder-home-buying"),
  component: FirstResponderHomeBuyingPage,
});
